export const SUPPORTED_LANGUAGES = [
  'english',
  'hindi',
  'kannada',
] as const;

export type Language = (typeof SUPPORTED_LANGUAGES)[number];

export interface ArtworkTranslation {
  title?: string;
  artist?: string;
  description?: string;
}

export interface Artwork {
  id: string;
  title: string;
  artist?: string;
  imageUrl?: string;
  description?: string;
  size_in_inches?: string;
  year_of_creation?: string;
  medium_of_artwork?: string;
  translations?: Partial<Record<Language, ArtworkTranslation>>;
  audioUrls?: Partial<Record<Language | string, string | null>>;
  audio?: Partial<Record<Language | string, string | null>>;
  audioUrl?: string;
}

export interface AudioState {
  isPlaying: boolean;
  currentTime: number;
  duration: number;
}
